import React from "react";
import { Breadcrumb, Card, Col, Flex, Image, Row } from "antd";
import { CustomTitle } from "../../components";
import { Link, useLocation } from "react-router-dom";
import CustomsContact from "../Airports/components/CustomsContact";


// Assets
import img1 from "../../assets/images/airline-img1.png";
import img2 from "../../assets/images/airline-img2.png";
import img3 from "../../assets/images/airline-img3.png";
import img4 from "../../assets/images/airline-img4.png";
import { ChevronRightIcon } from "../../assets/icons/icons";
import Breadcrumbs from "../../components/Breadcrumbs";

const airlineList = [
  { name: "American Airlines", img: img1 },
  { name: "Delta Airlines", img: img2 },
  { name: "Southwest Airlines", img: img3 },
  { name: "United Airlines", img: img4 },
];

const AirlineList = () => {
  const location = useLocation();
  const airport = location.state?.airport;

  const breadcrumbItems = [
    {
      title: "Airports",
      href: "/airport-list",
    },
    {
      title: airport?.name,
    },
  ];
  return (
    <>
      <section className="airline-list">
        <Flex vertical gap={16}>
          <Breadcrumbs items={breadcrumbItems} />
          <CustomTitle
            className="zl-custom-title"
            text={airport?.name}
            fontSize="24px"
            fontWeight="700"
            lineHeight="32px"
            color="black"
            marginBottom="0"
          />
        </Flex>
        <Flex vertical gap={12} className="airline-data">
          <CustomTitle
            text="Select from available airlines:"
            fontSize="12px"
            fontWeight="400"
            lineHeight="20px"
            color="black"
            marginBottom="0"
          />
          <Row gutter={[16, 24]}>
            {airlineList.map((airline, index) => (
              <Col key={index} xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
                <Link
                  to={`/airline-detail/${airline.name
                    .replace(/\s+/g, "-")
                    .toLowerCase()}`}
                  state={{ airport, airline }}
                >
                  <Card className="airline-card">
                    <CustomTitle
                      className="airline-name"
                      text={airline.name}
                      fontSize="18px"
                      fontWeight="700"
                      lineHeight="24px"
                      color="black"
                      marginBottom="0"
                    />
                    <Image
                      className="airline-img zl-custom-img"
                      src={airline.img}
                      preview={false}
                      alt={airline.name}
                      style={{ width: "100%" }}
                    />
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
          <Row gutter={[16, 24]}>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
             <CustomsContact airportName={airport?.name} iataCode={airport?.code} />
            </Col>
          </Row>
        </Flex>
      </section>
    </>
  );
};

export default AirlineList;
